const en = {
    general: {
        open: 'Open',
        close: 'Close',
        clear: 'Clear',
        error: 'Internal server error',
        empty: 'No data',
    },
    primitives: {
        Actions: {
            accept: 'Accept',
            cancel: 'Cancel',
            selected: 'Selected values:',
        },
        Pagination: {
            prev: 'Prev',
            next: 'Next',
            jumpto: 'to page',
        },
    },
    components: {
        Status: {
            button: 'Go main',
            phone: 'Tel',
            schedule: 'Schedule: from 9:00 to 21:00',
            Forbidden: {
                title: 'Forbidden',
                description: 'Contact the support center to get access',
            },
            NotFound: {
                title: 'Page not found',
                description: 'Try another link or return to the main page',
            },
            InternalServerError: {
                title: 'Internal server error',
                description: 'Page is unavailable at this moment - try again in few minutes',
            },
        },
        ActionsButton: {
            button: 'Actions',
        },
        Filters: {
            title: 'Table filtering',
            reset: 'Reset all filters',
        },
        ColumnsSettings: {
            title: 'Table settings',
            reset: 'Reset to default',
        },
    },
    features: {
        Table: {
            filter: 'Filtering',
            sorter: 'Sorting',
            ascending: 'Ascending',
            descending: 'Descending',
            pin: 'Pin',
            unpin: 'Unpin',
            hide: 'Hide',
            column: 'Column',
            reset: 'Reset',
            settings: 'Settings',
        },
    },
};

export { en };
//# sourceMappingURL=en.js.map
